// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"65581def","487":"c4f7bb2a"}[chunkId] + ".chunk.js";
};